import { Add, Remove } from '@mui/icons-material';
import { FormControl, FormLabel, Grid, IconButton, TextField, Typography } from '@mui/material';
import { useActividadesContext } from '../../UmmIACategories/Hook/useActividades';

const NumeroParticipantesTaller = () => {
    const { promptData, setPromptData} = useActividadesContext();
   
    const handleInputChange = (event) => {
        const newValue = event.target.value === '' ? '' : Number(event.target.value);
        setPromptData((prevData) => ({
            ...prevData,
            numero_participantes_taller: newValue,
        }));
    };

    const handleIncrement = () => {
        setPromptData((prevData) => ({
            ...prevData,
            numero_participantes_taller: Math.min(prevData.numero_participantes_taller + 1, 50),
        }));
    };

    const handleDecrement = () => {
        setPromptData((prevData) => ({
            ...prevData,
            numero_participantes_taller: Math.max(prevData.numero_participantes_taller - 1, 1),
        }));
    };

    return (
        <Grid sx={{ mb: 3 }}>
            <FormControl component="fieldset">
                <Typography sx={{ fontFamily: 'montserrat', fontSize: '1.25rem', fontWeight: 'bold', color: '#336B87' }}>
                    Número estimado de participantes *
                </Typography>
                <FormLabel component="p" sx={{ fontFamily: 'montserrat', fontSize: '0.85rem', mt: 0.2 }}>
                    Escribe el número máximo de participantes que pueden inscribirse en el taller
                </FormLabel>
                <Grid container alignItems="center" justifyContent="space-between" spacing={2} width={600}>


                    <Grid item xs={6} container spacing={1}>
                        <Grid item>
                            <IconButton onClick={handleDecrement} disabled={promptData.numero_participantes_taller <= 1}>
                                <Remove />
                            </IconButton>
                        </Grid>
                        <Grid item>
                            <TextField

                                variant="standard"
                                value={promptData.numero_participantes_taller}
                                onChange={handleInputChange}
                                inputProps={{
                                    step: 5,
                                    min: 5,
                                    max: 90,
                                    type: 'text',
                                    fontFamily: 'montserrat',
                                    color: '#336B87',
                                    sx: { fontFamily: 'montserrat', color: '#336B87', textAlign: 'center' }
                                }}
                                sx={{ width: 40, textAlign: 'center', fontFamily: 'montserrat', color: '#336B87' }}
                            />
                        </Grid>

                        <Grid item>
                            <IconButton onClick={handleIncrement} disabled={promptData.numero_participantes_taller >= 100}>
                                <Add />
                            </IconButton>
                        </Grid>
                    </Grid>
                </Grid>
            </FormControl>
        </Grid>
    );
};

export default NumeroParticipantesTaller;
